import ApiError from '../api/api-error';

export const getMessages = (content: string | string[] | Error | null): string[] => {
  if (!content) return [];
  if (Array.isArray(content)) return content;
  if (typeof content === 'string') return [content];
  if (content instanceof ApiError) return content.errors;
  return [content.message];
};
